import { render, staticRenderFns } from "./permissionlist.vue?vue&type=template&id=243f2c38&scoped=true&"
import script from "./permissionlist.vue?vue&type=script&lang=js&"
export * from "./permissionlist.vue?vue&type=script&lang=js&"
import style0 from "./permissionlist.vue?vue&type=style&index=0&id=243f2c38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243f2c38",
  null
  
)

export default component.exports